import React, { useState, useEffect, useRef }  from 'react';
import moment from 'moment'
import ReportTable from '../../../components/Reports/ReportTable/ReportTable';
import { TableIcons } from '../../../../constants/tableIcons';
import { firestore } from '../../../../firebase/firebase'
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/index';
import JobOptions from '../../../components/Reports/Jobs/JobOptions'
import { Paper, IconButton, Typography, Modal, Grid, Button } from '@material-ui/core';
import ReportSelect from '../../../components/Reports/ReportSelect'
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import _  from 'lodash'
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MediaViewer from '../../../components/UI/MediaViewer/MediaViewer';
import { Skeleton } from '@material-ui/lab';
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import useTicket from '../../Ticket/useTicket';
import { PostAdd } from '@material-ui/icons';
import { useCustomer } from '../../../../providers/CustomerContext';
import { useUnitDescription } from '../../../../providers/UnitDescriptionContext';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: '32px',
        paddingRight: '230px',
        overflow: 'auto'
    },

    sidebar: {
        position: 'fixed',
        right: 0,
        top: '64px',
        maxWidth: '256px',
        width: '100%',
        padding: '16px',
        minHeight: '100vh',
        zIndex: '1000',
    },
    expand: {
        position: 'fixed',
        right: 0,
        top: '444px',
        transform: 'rotate(90deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        position: 'fixed',
        right: 253,
        top: '444px',
        transform: 'rotate(270deg)',
    },
    modal: {
        width: '250px',
        padding: '16px',
        margin: '0 auto',
        marginTop: '50vh',
    },
}));

const JobReport = (props) => {
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();
    const { createTicketFromSource } = useTicket();
    const { customers, getCustomers, customerLoading } = useCustomer();
    const { units, getUnits } = useUnitDescription();
    const tableRef = useRef(ReportTable);

    const [startDate, setStartDate] = useState("startDate" in sessionStorage ? moment(JSON.parse(sessionStorage.getItem("startDate"))) : moment());
    const [endDate, setEndDate] = useState("endDate" in sessionStorage ? moment(JSON.parse(sessionStorage.getItem("endDate"))) : moment());
    const [progress, setProgress] = useState(0);
    const [loadingText, setLoadingText] = useState("");
    const [checkboxState, setChecked] = useState({
        photos: ("jobCheckbox" in sessionStorage ? JSON.parse(sessionStorage.getItem("jobCheckbox")) : false),
        nophotos: true,
        checklists: true,
        notes: true,
    });

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    //const [searchBarValue] = useState("jobsSearchBarValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("jobsSearchBarValue")) : null)
    const [ticketModal, setTicketModal] = useState({open: false, data: [], progress: 0, error: null, batchTicket: false})
    const [searchState, setSearch] = useState({
        type: JSON.parse(sessionStorage.getItem("jobOptionsSearchType")) || 'customer',
        value: JSON.parse(sessionStorage.getItem("jobOptionsSearch")) || '',
    });
    const [customerAutoCompleteModal, setCustomerAutoCompleteModal] = useState({open: false, value: {}})
    const [jobTypeState, setJobType] = useState({
        //type: JSON.parse(sessionStorage.getItem("jobOptionsType")) || 'snow',
        value: '',
        jobType: JSON.parse(sessionStorage.getItem("jobOptionsType")) || 'snow',
    });
    const [expanded, setExpanded] = useState(JSON.parse(sessionStorage.getItem("reportExpanded")) || true);
    const [open, setOpen] = React.useState(false);
    const [photos] = React.useState([]);

    useEffect(() => {
        getCustomers();
        getUnits();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const checkboxHandler = (event) => {
        setChecked({ ...checkboxState, [event.target.name]: event.target.checked });
        sessionStorage.setItem("jobCheckbox", JSON.stringify(event.target.checked))
    };

    const handlePrint = () => {
        props.history.push({
            pathname: '/dashboard/reporting/jobs/printing/table/',
            state: { data: mergeData(), jobData: props.jobData, hours: hours }
        })
    }

    const handlePrintJobReport = () => {
        props.history.push({
            pathname: '/dashboard/reporting/jobs/printing/report/',
            state: { data: tableRef?.current?.state?.data, jobData: props.jobData, hours: hours}
        })
    }

    const startDateHandler = date => {
        setStartDate(date)
        sessionStorage.setItem("startDate", JSON.stringify(date))
    }
    const endDateHandler = date => {
        setEndDate(date)
        sessionStorage.setItem("endDate", JSON.stringify(date))
    }

    const autocompleteChangeHandler = (value) => {
        setSearch({ ...searchState, 'value': value })
        sessionStorage.setItem("jobOptionsSearch", JSON.stringify(value))
    }

    const searchHandler = (event) => {
        setSearch({ ...searchState, [event.target.name]: event.target.value })
        if(event.target.name === "type") sessionStorage.setItem("jobOptionsSearchType", JSON.stringify(event.target.value))
        if(event.target.name === "value") sessionStorage.setItem("jobOptionsSearch", JSON.stringify(event.target.value))
    }

    const jobTypeHandler = (event) => {
        setJobType({ ...jobTypeState, [event.target.name]: event.target.value })
        sessionStorage.setItem("jobOptionsType", JSON.stringify(event.target.value))
    }

    const clearSearch = () => {
        setSearch({ ...searchState, value: '' });
        sessionStorage.removeItem("jobOptionsSearch");
    }

    const handleCreateTicket = (jobArray, batch) => {
        setTicketModal({...ticketModal, progress: 1, error: null,})
        createTicketFromSource(jobArray, props.jobData, 'jobs', batch).then((res) => {

            props.updateTableCache('jobReport', {jobData: res, checklistData: props.checklistData, timesheetData: props.timesheetData, unitData: props.unitData})
            setTicketModal({open: false, data: [], progress: 0, error: null, batchTicket: false})
        })
        .catch(err => {
            setTicketModal({open: true, data: [], progress: 0, error: err, batchTicket: false})
        })
    }

    const handleNavigateToTicket = (docIdArray) => {
        props.history.push({
            pathname: '/dashboard/tickets',
            docId: docIdArray[0],
            batch: docIdArray,
        })
    }

    async function dateCompat() {
        let query = firestore.collection('jobs')

        if (searchState.type === 'type') {
            query = query.where("jobType", "==", jobTypeState.jobType);
        }
        query.orderBy('date')

        const oldDate = query.where("date", ">=", startDate.startOf('day').unix()).where("date", "<=", endDate.endOf('day').unix()).get()
        const newDate = query.where("date", ">=", startDate.startOf('day').utc().valueOf()).where("date", "<=", endDate.endOf('day').utc().valueOf()).get()

        const [oldDateSnapshot, newDateSnapshot] = await Promise.all([newDate, oldDate]).catch((err) => console.log(err))

        const oldDateArray = oldDateSnapshot.docs
        const newDateArray = newDateSnapshot.docs
        return _.concat(oldDateArray, newDateArray)
    }
    
    const generateHandler = () => {

        let unitResponse = []
        let jobResponse = []
        let timesheetResponse = []
        let checklistResponse = []

        setProgress(1)
        setLoadingText("Preparing Cache")
        setErrorMessage(null);

        setLoading(true);
        setProgress(10)
        setLoadingText("Grabbing Job data...")
        dateCompat().then(querySnapshot => {
            jobResponse = querySnapshot.map((doc) => {

                return {
                    ...doc.data(),
                    'docId': doc.id,

                }
            })
            setProgress(15)

            setLoadingText("Applying search filter..")
            if (checkboxState.photos) {
                jobResponse = jobResponse.filter(job => job.photoURLs.length > 0)
            }

            if (searchState.value !== "" && searchState.value !== null) {
                switch (searchState.type) {
                    case 'customer':
                        jobResponse = jobResponse.filter(job => job.customerID === searchState.value)
                        break;
                    default:
                        break;
                }
            }

            setProgress(25)
            setLoadingText("Grabbing Timesheet data...")

            return firestore.collection('timesheets').orderBy('date').startAt(startDate.startOf('day').valueOf()).endAt(endDate.endOf('day').valueOf()).where("date", ">=", startDate.startOf('day').valueOf()).where("date", "<=", endDate.endOf('day').valueOf()).get();
        }).then((querySnapshot) => {
            setProgress(35)
            timesheetResponse = querySnapshot.docs.map((doc) => {
                return { 
                    'docId': doc.id,
                    'date': doc.data().date,
                    'inTime': doc.data().usingGateInTime ? doc.data().gateIn15 : doc.data().inTime,
                    'offHours': doc.data().offHours,
                    'operatorHours': doc.data().operatorHours,
                    'outTime': doc.data().usingGateOutTime ? doc.data().gateOut15 : doc.data().outTime,
                    'timesheetID': doc.data().timesheetID,

                 }

            });
            setProgress(50)
            setLoadingText("Grabbing Checklist data..")

            //TODO: work out why date filters for checklists dont work
            return firestore.collection('checklists').where("date", ">=", startDate.startOf('day').valueOf()/1000).where("date", "<=", endDate.endOf('day').valueOf()/1000).get();
        }).then((querySnapshot) => {
            setProgress(60)
            checklistResponse = querySnapshot.docs.map((doc) => {
                return { ...doc.data(),
                    'docId': doc.id,
                    'serviceType': doc.data().serviceType,
                    'serviceReason': doc.data().serviceReason,
                    'date': doc.data().date,
                    'equipmentType': doc.data().equipmentType,
                      
                }
            });
            setProgress(75)
            setLoadingText("Grabbing Unit data...")
            return firestore.collection('units').where("date", ">=", startDate.startOf('day').valueOf()).where("date", "<=", endDate.endOf('day').valueOf()).get();
        }).then((querySnapshot) => {
            setProgress(80)
            unitResponse = querySnapshot.docs.map((doc) => {
                return { 
                    'docId': doc.id,
                    'unitNumber': doc.data().unitNumber
                }
            });
            setProgress(90)
            setLoadingText("Checking Cache..")
        }).then(() => {
            props.updateTableCache('jobReport', {jobData: jobResponse, checklistData: checklistResponse, timesheetData: timesheetResponse, unitData: unitResponse})
            setProgress(99)
            //should have required data
            setLoading(false);
            setLoadingText("Complete.")
            setTimeout(() => {
                setProgress(100)
            }, 3000);
        }).catch(e => {
            setErrorMessage(`Unable to process due to: ${e.message}`);
            console.log(e.message);
            setLoading(false);
            setProgress(0);
            props.updateTableCache('jobReport', {jobData: [], checklistData: [], timesheetData: [], unitData: []})
        });
    }

    const handleExpandClick = () => {
        if(expanded)
            setExpanded(false);
        else
            setExpanded(true);    
        sessionStorage.setItem("reportExpanded", JSON.stringify(expanded))
    };
    const error = [checkboxState.unseen, checkboxState.viewed, checkboxState.printed].filter((v) => v).length < 1;

    function mergeData() {
        return props.jobData.map(x => {
            if (x.outTime < 9999999999) x.outTime *= 1000
            if (x.inTime < 9999999999) x.inTime *= 1000
            x.fullTime = x.timeOut === 0 ? "In Progress" : Number(((x.timeOut - x.timeIn) / 3600000).toFixed(2))
            if(x.expandedTime !== undefined){
                x.fullTime += Number(x.expandedTime)
                x.fullTime = Number(x.fullTime).toFixed(2)
            }
            const checklists = props.checklistData.filter(checklist => checklist.jobID === x.docId);
            const timesheets = props.timesheetData.filter(timesheet => timesheet.docId === x.timesheetID);
            const units = props.unitData.filter(unit => x.units.includes(unit.docId));
            x.opHours = ((x.outTime - x.inTime - (((x.skipLunch === 'na' || x.skipLunch === 'declined') ? 1800000 : 0))) / 3600000) - x.offHours
            x.opHours = Math.max(x.opHours.toFixed(2), 0);
            x.timesheet = timesheets.filter(timesheet => timesheet.docId === x.timesheetID)
            x.checklist = checklists.filter(checklist => checklist.jobID === x.docId)
            x.unitObjs = units
            x.unitList = []
            units.forEach(unit => {
                x.unitList.push(unit.unitNumber)
            })
            return {
                ...x,
                //timesheet: timesheets.map(timesheet => timesheet.timesheetID),
            }
        });

    }
    function calcHours() {
        return props.jobData.map(x => {
            if (x.timeOut < 9999999999) x.timeOut *= 1000
            if (x.timeIn < 9999999999) x.timeIn *= 1000
            x.opHours = ((x.timeOut - x.timeIn ) / 3600000)
            x.opHours = Math.max(x.opHours.toFixed(2), 0);
            return { time: x.opHours }
        }).reduce((total, timesheet) => total + timesheet.time, 0).toFixed(2)
    }
    const hours = calcHours();

    return (
        <React.Fragment>
            {/* send to ticket modal */}
            <Modal
                open={ticketModal.open}
                onClose={() => setTicketModal({...ticketModal, open: false, data: [], error: null, collection: null}) }
            >
                <Paper className={classes.modal}>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        <Typography
                            style={{ margin: '10px', display: 'flex', justifyContent: 'center', fontWeight: '600', }}
                        >
                            Send Job to Tickets?
                        </Typography>
                    </Grid>

                    {
                        ticketModal.data[0]?.units?.length > 1 ?
                        <Grid>
                            <Typography style={{fontSize: '11px'}}>
                                {`Source has more than one unit, create one ticket or batch based on units?`}
                            </Typography>
                            
                            <Grid style={{display: 'flex', justifyContent: 'center'}}>
                                <Button
                                    variant={ticketModal.batchTicket ? 'outlined' : 'contained'}
                                    style={{margin: '10px', }}
                                    onClick={() => { setTicketModal({...ticketModal, batchTicket: false}) }}
                                >
                                    Single
                                </Button>
                                <Button
                                    variant={ticketModal.batchTicket ? 'contained' : 'outlined'}
                                    style={{margin: '10px'}}
                                    onClick={() => { setTicketModal({...ticketModal, batchTicket: true}) }}
                                >
                                    Batch
                                </Button>
                            </Grid>
                        </Grid>
                        : null
                    }
                    
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            variant={'contained'}
                            style={{margin: '10px', }}
                            onClick={() => { setTicketModal({...ticketModal, open: false, data: [], error: null, batchTicket: false}) }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant={'contained'}
                            style={{margin: '10px'}}
                            disabled={ticketModal.progress !== 0 || ticketModal.error !== null}
                            onClick={() => { handleCreateTicket(ticketModal.data, ticketModal.batchTicket) }}
                        >
                            {ticketModal.progress === 0 ? 'Confirm' : 'Processing'}
                        </Button>
                    </Grid>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        {ticketModal.error && <Typography style={{color: 'red', marginTop: '5px'}}><small>{ticketModal.error}</small></Typography>}
                    </Grid>
                </Paper>
            </Modal>

            <div className={classes.content}
            style={expanded ? {paddingRight: '260px' } : {paddingRight: smallScreen ? '12px' : '230px' }} >
                {photos.length > 0 ? <MediaViewer open={open} handleClose={() => setOpen(false)} photoURLs={photos} /> : null}
                {progress === 0 || progress === 100 || progress === 99 ?
                <ReportTable
                    tableRef={tableRef}
                    columns={ [
                        {   title: 'Customer', field: 'customer',
                            render: rowData => {
                                let customerName = customers.find(x=> x.docId === rowData.customerID)?.name || rowData.customer
                                return !_.isUndefined(customerName) ? customerName : ''
                            },
                            exportTransformer: (rowData) => {
                                let customerName = customers.find(x=> x.docId === rowData.customerID)?.name || rowData.customer
                                return !_.isUndefined(customerName) ? customerName : ''
                            },
                            customSort: (a, b) => {
                                let aContainer = customers.find(x=> x.docId === a.customerID)?.name || a.customer
                                let bContainer = customers.find(x=> x.docId === b.customerID)?.name || b.customer
                                return ( aContainer?.toLowerCase() > bContainer?.toLowerCase() ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let customerName = customers.find(x=> x.docId === rowData.customerID)?.name || rowData.customer
                                return (customerName.toLowerCase().indexOf(term.toLowerCase()) !== -1)
                            },
                        },
                        { title: 'Address', field: 'address', width:'20%',
                            render: rowData => {
                                let customer = customers.find(x=> x.docId === rowData.customerID)
                                let customerAddy = !_.isUndefined(customer) ? `${customer.streetNumber} ${customer.streetName}` : rowData.address
                                return (!_.isUndefined(customerAddy) ? customerAddy : '')
                            },
                            exportTransformer: (rowData) => {
                                let customer = customers.find(x=> x.docId === rowData.customerID)
                                let customerAddy = !_.isUndefined(customer) ? `${customer.streetNumber} ${customer.streetName}` : rowData.address
                                return (!_.isUndefined(customerAddy) ? customerAddy : '')
                            },
                            customSort: (a, b) => {
                                let aCustomer = customers.find(x=> x.docId === a.customerID)
                                let bCustomer = customers.find(x=> x.docId === b.customerID)
                                let aContainer = !_.isUndefined(aCustomer) ? `${aCustomer.streetNumber} ${aCustomer.streetName}` : a.address
                                let bContainer = !_.isUndefined(bCustomer) ? `${bCustomer.streetNumber} ${bCustomer.streetName}` : b.address
                                return ( aContainer?.toLowerCase() > bContainer?.toLowerCase() ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let customer = customers.find(x=> x.docId === rowData.customerID)
                                let customerAddy = !_.isUndefined(customer) ? `${customer.streetNumber} ${customer.streetName}` : rowData.address
                                return (customerAddy.toLowerCase().indexOf(term.toLowerCase()) !== -1)
                            },
                         },
                        {
                            title: 'Time In', field: 'timeIn', 
                            render: rowData => {
                                if (rowData.timeIn < 9999999999){ rowData.timeIn *= 1000 }
                                return moment(rowData.timeIn).format('YYYY-MM-DD h:mm a')
                            },
                            exportTransformer: (rowData) => {
                                if (rowData.timeIn < 9999999999){ rowData.timeIn *= 1000 }
                                return moment(rowData.timeIn).format('YYYY-MM-DD h:mm a')
                            },
                            customSort: (a, b) => {
                                let aTimeIn = a.timeIn < 9999999999 ? (a.timeIn * 1000) : a.timeIn
                                let bTimeIn = b.timeIn < 9999999999 ? (b.timeIn * 1000) : b.timeIn
                                let aContainer = moment(moment(aTimeIn).format('YYYY-MM-DD h:mm a'), ['YYYY-MM-DD h:mm a'])
                                let bContainer = moment(moment(bTimeIn).format('YYYY-MM-DD h:mm a'), ['YYYY-MM-DD h:mm a'])
                                return ( aContainer.isAfter(bContainer) ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let value = rowData.timeIn
                                if (value < 9999999999){ value *= 1000 }
                                value = moment(rowData.timeIn).format('YYYY-MM-DD h:mm a')
                                return value.indexOf(term.toLowerCase()) !== -1
                            },
                        },
                        {
                            title: 'Time Out', field: 'timeOut', 
                            render: rowData => {
                                if (rowData.timeOut < 9999999999) rowData.timeOut *= 1000
                                return moment(rowData.timeOut).format('YYYY-MM-DD h:mm a')
                            },
                            exportTransformer: (rowData) => {
                                if (rowData.timeOut < 9999999999) rowData.timeOut *= 1000
                                return moment(rowData.timeOut).format('YYYY-MM-DD h:mm a')
                            },
                            customSort: (a, b) => {
                                let aTimeOut = a.timeOut < 9999999999 ? (a.timeOut * 1000) : a.timeOut
                                let bTimeOut = b.timeOut < 9999999999 ? (b.timeOut * 1000) : b.timeOut
                                let aContainer = moment(moment(aTimeOut).format('YYYY-MM-DD h:mm a'), ['YYYY-MM-DD h:mm a'])
                                let bContainer = moment(moment(bTimeOut).format('YYYY-MM-DD h:mm a'), ['YYYY-MM-DD h:mm a'])
                                return ( aContainer.isAfter(bContainer) ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let value = rowData.timeOut
                                if (value < 9999999999){ value *= 1000 }
                                value = moment(rowData.timeOut).format('YYYY-MM-DD h:mm a')
                                return value.indexOf(term.toLowerCase()) !== -1
                            },
                        },
                        {
                            title: 'Job Time', width: '1%', field:'fullTime',
                        },
                        {
                            title: 'Timesheet', field: 'timesheet', width: '1%', 
                            render: rowData => {
                                if(rowData.timeOut === 0) return "N/A"
                                return rowData?.timesheet?.[0]?.timesheetID
                            },
                            exportTransformer: (rowData) => {
                                if(rowData.timeOut === 0) return "N/A"
                                return rowData?.timesheet?.[0]?.timesheetID
                            },
                            customSort: (a, b) => { 
                                return a?.timesheet?.[0]?.timesheetID < b?.timesheet?.[0]?.timesheetID ? 1 : -1 
                            },  
                            customFilterAndSearch: (term, rowData) => {
                                let value = (rowData?.timesheet?.[0]?.timesheetID).toString()
                                return value.indexOf(term) !== -1
                            },
                        },
                        {
                            title: 'Units', field: 'unitObjs' , 
                            render: rowData => {
                                let newUnitArray = rowData.unitObjs.map((uni) => { 
                                    let foundUnit = units.find(x=> x.docId === uni.parentUnitDocId)
                                    return !_.isUndefined(foundUnit) ? foundUnit.unitNumber : uni.unitNumber
                                })
                                return newUnitArray.map((uni, index) => <Typography key={index}>{uni}</Typography>)
                            },   
                            exportTransformer: (rowData) => {
                                let newUnitArray = rowData.unitObjs.map((uni) => { 
                                    let foundUnit = units.find(x=> x.docId === uni.parentUnitDocId)
                                    return !_.isUndefined(foundUnit) ? foundUnit.unitNumber : uni.unitNumber
                                })
                                return newUnitArray.map((uni) => uni )
                            },     
                            customSort: (a, b) => {
                                let aContainer = units.find(x=> x.docId === a.unitObjs[0]?.parentUnitDocId)?.unitNumber || a.unitObjs[0]?.unitNumber
                                let bContainer = units.find(x=> x.docId === b.unitObjs[0]?.parentUnitDocId)?.unitNumber || b.unitObjs[0]?.unitNumber
                                if(!_.isUndefined(aContainer) && _.isUndefined(bContainer)){  return 1 }
                                else if(_.isUndefined(aContainer) && !_.isUndefined(bContainer)){ return -1 }
                                else{ return aContainer?.toLowerCase() > bContainer?.toLowerCase() ? 1 : -1 }
                            },
                            customFilterAndSearch: (term, rowData) => {
                                let returnValue = false
                                let newUnitArray = rowData.unitObjs.map((uni) => { 
                                    let foundUnit = units.find(x=> x.docId === uni.parentUnitDocId)
                                    return !_.isUndefined(foundUnit) ? foundUnit.unitNumber : uni.unitNumber
                                })
                                newUnitArray?.forEach((unitNum) => { if(unitNum.toLowerCase().indexOf(term.toLowerCase()) !== -1){ returnValue = true } })
                                return returnValue
                            },
                        },
                    ]}
                    data={mergeData()}
                    title={`Jobs - Total Hours: ${hours}`}
                    icons={TableIcons}
                    isLoading={loading}
                    pathname='/dashboard/reporting/timesheets/job'
                    actions={[
                        rowData => ({
                            icon: () => <PostAdd style={!_.isEmpty(rowData.associatedTickets) ? {color: 'green'} : null} /> ,
                            tooltip: !_.isEmpty(rowData.associatedTickets) ? 'Go to Ticket' : 'Send to Ticket',
                            onClick: (event, rowData) => { !_.isEmpty(rowData.associatedTickets) ?  handleNavigateToTicket(rowData.associatedTickets) : setTicketModal({...ticketModal, open: true, data: [rowData], error: null} )},
                        }),
                    ]}
                    onSearchChange={ (value) => { sessionStorage.setItem("jobReportSearchBarValue", JSON.stringify(value)) }}
                    onRowsPerPageChange={(num) => { sessionStorage.setItem("jobReportRowsPerPage", JSON.parse(num)) }}
                    onPageChange={ (pageNum) => { sessionStorage.setItem("jobReportPageValue", JSON.stringify(pageNum)) }}
                    options={{
                        pageSize: "jobReportRowsPerPage" in sessionStorage ? JSON.parse(sessionStorage.getItem("jobReportRowsPerPage")) : 40,
                        initialPage: "jobReportPageValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("jobReportPageValue")) : 0,
                        pageSizeOptions: [5, 10, 20, 40, 50, 100],
                        toolbar: true,
                        paging: true,
                        columnsButton: true,
                        searchText: "jobReportSearchBarValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("jobReportSearchBarValue")) : '',
                        //actionsColumnIndex: -1,
                        thirdSortClick: true,
                        exportMenu: [
                            {
                                label: "Export CSV",
                                exportFunc: (cols) => ExportCsv(cols, tableRef?.current?.state?.data, `JobReportData`),
                            },
                            {
                                label: "Export PDF",
                                exportFunc: (cols) => ExportPdf(cols, tableRef?.current?.state?.data, `JobReportData`),
                            },
                        ],
                    }}
                /> 
                : <Skeleton variant='rect' width={'80vw'} height={'250vh'}/>}
                
                {smallScreen ?
                <div>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        >
                        <ExpandMoreIcon style={{fontSize: '50px'}} />
                    </IconButton>
                    <Collapse orientation="horizontal" in={expanded} timeout="auto" >
                        <Paper className={classes.sidebar}>
                            <ReportSelect
                                reportType={props.reportType}
                                onchange={props.onchange}
                            />
                            <JobOptions
                                checkboxState={checkboxState} 
                                handler={checkboxHandler}
                                searchState={searchState} 
                                searchHandler={searchHandler} 
                                jobTypeState={jobTypeState} 
                                jobTypeHandler={jobTypeHandler}
                                clearSearch={clearSearch}
                                startDate={startDate} 
                                startDateHandler={startDateHandler}
                                endDate={endDate} 
                                endDateHandler={endDateHandler}
                                generateHandler={generateHandler}
                                errorMsg={errorMessage}
                                loading={loading}
                                error={error}
                                handlePrint={handlePrint}
                                handlePrintJobReport={handlePrintJobReport}
                                customerAutoCompleteModal={customerAutoCompleteModal}
                                setCustomerAutoCompleteModal={setCustomerAutoCompleteModal}
                                customerLoading={customerLoading}
                                customers={customers}
                                autocompleteChangeHandler={autocompleteChangeHandler}
                            />
                        </Paper>
                    </Collapse>
                </div>
                :
                <div>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        >
                        <ExpandMoreIcon style={{fontSize: '50px'}} />
                    </IconButton>
                    <Collapse orientation="horizontal" in={expanded} timeout="auto" >
                        <Paper className={classes.sidebar}>
                            <ReportSelect
                                reportType={props.reportType}
                                onchange={props.onchange}
                            />
                            <JobOptions
                                checkboxState={checkboxState} 
                                handler={checkboxHandler}
                                searchState={searchState} 
                                searchHandler={searchHandler}
                                jobTypeState={jobTypeState} 
                                jobTypeHandler={jobTypeHandler}
                                clearSearch={clearSearch}
                                startDate={startDate} 
                                startDateHandler={startDateHandler}
                                endDate={endDate} 
                                endDateHandler={endDateHandler}
                                generateHandler={generateHandler}
                                errorMsg={errorMessage}
                                loading={loading}
                                error={error}
                                handlePrint={handlePrint}
                                progress={progress} 
                                loadingText={loadingText} 
                                checkboxHandler={checkboxHandler}
                                handlePrintJobReport={handlePrintJobReport}
                                customerAutoCompleteModal={customerAutoCompleteModal}
                                setCustomerAutoCompleteModal={setCustomerAutoCompleteModal}
                                customerLoading={customerLoading}
                                customers={customers}
                                autocompleteChangeHandler={autocompleteChangeHandler}
                            />
                        </Paper>
                    </Collapse>
                </div>
}
            </div>
        </React.Fragment>
    )
}

//Map slice of global state to props
const mapStateToProps = (state) => {
    return {
        // state refers to global state/ redux state (acts somewhat like singleton)
        // "products" is the name given in index.js to the state of our reducer
        // the props: featuredProducts and loading come from the reducer productsReducer.js
        //cart: state.cart.cart,
        jobData: state.tableCache.jobReport.jobData,
        unitData: state.tableCache.jobReport.unitData,
        timesheetData: state.tableCache.jobReport.timesheetData,
        checklistData: state.tableCache.jobReport.checklistData,
    };
}


//map our dispatch functions to props
const mapDispatchToProps = dispatch => {
    return {
        updateTableCache: (tableKey, tableValue) => dispatch(actionCreators.updateTableCache(tableKey, tableValue)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobReport));